import { render } from "./ResizableGrid.vue?vue&type=template&id=61afb3e9&scoped=true&ts=true"
import script from "./ResizableGrid.vue?vue&type=script&lang=ts"
export * from "./ResizableGrid.vue?vue&type=script&lang=ts"

import "./ResizableGrid.vue?vue&type=style&index=0&id=61afb3e9&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61afb3e9"]])

export default __exports__